export const brazeConfigVzla = {
  production: {
    apiKey: 'b6ef7a66-982a-4bb7-9869-dbb512f54410',
    baseUrl: 'sdk.iad-06.braze.com'
  },
  testing: {
    apiKey: '9887dd14-9e82-47b9-9188-d4c84af07563',
    baseUrl: 'sdk.iad-06.braze.com'
  }
};
